import { ReactNode } from 'react';

const BOLD_PATTERN = /<b>(.*?)<\/b>/gis;

/**
 * Renders a string that may contain `<b>...</b>` markers as React
 * nodes, wrapping the marked segments in `<b>`. All other text -
 * including any other tags - is rendered as literal text.
 */
function renderBold(text: string): ReactNode {
  if (!text) {
    return text;
  }

  return text
    .split(BOLD_PATTERN)
    .map((part, index) => (index % 2 ? <b key={index}>{part}</b> : part));
}

/**
 * Removes `<b>...</b>` markers while keeping the text they wrap. Use where
 * plain text is required instead of nodes, such as an `aria-label`.
 */
export function stripBold(text: string): string {
  if (!text) {
    return text;
  }

  return text.replace(BOLD_PATTERN, '$1');
}

export default renderBold;
